export enum SkillApiErrorTypes {
  ServiceUnavailableError,
  NotFoundError,
  RequestValidationError,
}

export class SkillApiError {
  constructor(public type: SkillApiErrorTypes, public error: Error) {}
}
